import { render, staticRenderFns } from "./operateDetail.vue?vue&type=template&id=4629d504&scoped=true&"
import script from "../../order/detail/detail.js?vue&type=script&lang=js&"
export * from "../../order/detail/detail.js?vue&type=script&lang=js&"
import style0 from "./operateDetail.vue?vue&type=style&index=0&id=4629d504&lang=scss&scoped=true&"
import style1 from "./operateDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4629d504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4629d504')) {
      api.createRecord('4629d504', component.options)
    } else {
      api.reload('4629d504', component.options)
    }
    module.hot.accept("./operateDetail.vue?vue&type=template&id=4629d504&scoped=true&", function () {
      api.rerender('4629d504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/detailApi/operateDetail.vue"
export default component.exports